export default __webpack_public_path__ + "img/wow.a192adc4.svg";